export const SUBMIT_FORM = 'containers/LoginTerms/SUBMIT_FORM';
export const FORM_SUBMITTED_SUCCESS = 'containers/LoginTerms/FORM_SUBMITTED_SUCCESS';
export const FORM_SUBMITTED_FAIL = 'containers/LoginTerms/FORM_SUBMITTED_FAIL';
export const ERROR = 'containers/LoginTerms/ERROR';
export const RESET = 'containers/LoginTerms/RESET';
